<template>
  <div>
    <el-autocomplete class="inline-input" v-model="spotItem.spotName" 
      :fetch-suggestions="(queryString, cb) => {spotQuerySearch(queryString, cb, spotItem);}"
      placeholder="请选择景点" @select="spotHandleSelect($event,spotItem)" value-key="value"
      size="mini" style='width:1.7rem' slot="reference">
      <template slot-scope="{ item }">
        <div class="name">{{item.nameCn}}</div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import Api from '@/components/Api/index.js'
export default {
  props:{
    spotItem:{
      type:Object,
      default:()=>{return{}}
    }
  },
  methods:{
    spotQuerySearch(queryString, cb,spotItem){
      new Api('resource').spotList({name:queryString,cityId:this.spotItem.cityId}).then(res => {
        if (res.status == 200) {
          cb(res.data)
        }
      })
    },
    spotHandleSelect(item,spotItem){
      spotItem.spotId = item.id
      spotItem.spotName = item.nameCn
    },
  }
}
</script>

<style>

</style>